var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('check-box',{model:{value:(_vm.displayTimestamps),callback:function ($$v) {_vm.displayTimestamps=$$v},expression:"displayTimestamps"}},[_vm._v("Display chat timestamps")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4524e362","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user-settings/_components/chat-timestamps/chat-timestamps.html
// module id = null
// module chunks = 